import { JSONSchema7, JSONSchema7Definition } from "json-schema";
import { IFormSchema } from "../models/IFormSchema";

/**
 * Loops trough each schema property
 * @param properties 
 * @param invoke 
 * @param pathBase 
 */
export const forEachSchemaProperty = (
    properties: JSONSchema7["properties"],
    uiProperties: IFormSchema["uiSchema"],
    invoke: (path: string, prop: JSONSchema7Definition, uiProp: IFormSchema["uiSchema"]) => void,
    pathBase?: string
) => {

    if (!properties) { return; };

    Object.keys(properties).forEach((key) => {
        const prop = properties[key];
        const uiProp = uiProperties[key] || {};
        if (prop === true || prop === false) { return; };

        if (prop.type === "object" && !uiProp["ui:widget"]) {
            forEachSchemaProperty(prop.properties, uiProp, invoke, key);
            return;
        }

        const path = pathBase ? [pathBase, key].join(".") : key;
        invoke(path, prop, uiProp);
    });
};
